import React  from 'react'
import {Link} from 'react-router-dom'

import UseIsMobile from '../hooks/UseIsMobile.jsx';
import Renders from '../renders/Renders';

import WWWImage from '../assets/images/articles/WWW/www-02.jpg';
import NanImage from '../assets/images/articles/Nan/NAN_slide1-3.jpg';
import montageImage from '../assets/images/articles/montage/DSC05047.jpg';
import transitionImage from '../assets/images/articles/transitie/transition1.jpg';
import burenhinderImage from '../assets/images/articles/PostHuman/posthuman-party_3.jpg';
import llossImage from '../assets/images/articles/TwoTowers/twotowers-party-11.jpg';
import kioskImage from '../assets/images/articles/woodblocks/woodblocks-party-25.jpg';
import toolkitImage from '../assets/images/articles/toolkit/toolkit-07.jpg';
import calImage from '../assets/images/articles/CAL/CAL-1.jpg';
import ArchImage from '../assets/images/articles/Archipel/archipel-09.jpg';
import AucoinImage from '../assets/images/articles/Aucoin/Aucoin-5.jpg';


function Insituspage() {
  const isMobile = UseIsMobile();

  return (
    <div className='insitus' id='background'>
      <h1 className="insitus__title">Projects & Articles</h1>

      <div className='insitus__title editH1'>Projects & Articles</div>
      {/* Conditionally render the Renders component (WebGL) for desktop */}
      {!isMobile ? (
        <div className='insitus__renders__containers renderhide' >
          <Renders/>
        </div>
      ) : null}


      <div className='insitus__video__containers mobile'>
        <div className='video__wrapper'> 
          <img src={AucoinImage} alt="" />
        </div>
        <div className='video__wrapper'> 
          <img src={ArchImage} alt="" />
        </div>
        <div className='video__wrapper'> 
          <img src={calImage} alt="" />
        </div>
        <div className='video__wrapper'> 
          <img src={toolkitImage} alt="" />
        </div>
        <div className='video__wrapper'> 
          <img src={WWWImage} alt="" />
        </div>
        <div className='video__wrapper'> 
          <img src={NanImage} alt="" />
        </div>
        <div className='video__wrapper'> 
          <img src={montageImage} alt="" />
        </div>
        <div className='video__wrapper'>
          <img src={burenhinderImage} alt="" /> 
        </div>
        <div className='video__wrapper'>
          <img src={llossImage} alt="" /> 
        </div>
        <div className='video__wrapper'>
          <img src={transitionImage} alt="" /> 
        </div>
        <div className='video__wrapper'>
          <img src={kioskImage} alt="" /> 
        </div>
      </div>

      <div className='insitus__container'>
        <section className='insitus__section' id="cal">
          <Link to="/Aucoin">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Au coin - in den hoek</h1>
              <h2 className='editH2'>Anonymous | 18.10.2025</h2>
            </div>
          </Link>
        </section>
        <section className='insitus__section' id="cal">
          <Link to="/Archipel">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Archipel Workshop: <br /> ‘Temporality’</h1>
              <h2 className='editH2'>Otto van Sloun | 13.03.2025</h2>
            </div>
          </Link>
        </section>
        <section className='insitus__section' id="cal">
          <Link to="/cal">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>NOTES ON <br />’CLUB ACCESS LAB’</h1>
              <h2 className='editH2'>Tilde De Vylder | 08.04.2025</h2>
            </div>
          </Link>
        </section>
        <section className='insitus__section' id="toolkit">
          <Link to="/toolkit">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Toolkitweek:</h1>
              <h1 className='editH1'>Prototype Evening</h1>
              <h2 className='editH2'>Lars Marcoen & Otto Van Sloun | 31.01.2025</h2>
            </div>
          </Link>
        </section>
        <section className='insitus__section' id="www">
          <Link to="/www">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Design the playground:</h1>
              <h1 className='editH1'>a matter of collaboration</h1>
              <h2 className='editH2'>Cosima Rosie Lagae & Lars Marcoen | 04.03.2025</h2>
            </div>
          </Link>
        </section>
        <section className='insitus__section' id="nan">
          <Link to="/night-after-night">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>InSitu Atelier:</h1>
              <h1 className='editH1'>Night-After-Night</h1>
              <h2 className='editH2'> Lars Marcoen | 28.09.2024</h2>
            </div>
          </Link>
        </section>

        <section className='insitus__section' id="take-two-give-one">
          <Link to="/take-two-give-one">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>InSitu Atelier:</h1>
              <h1 className='editH1'>Take Two, Give One</h1>
              <h2 className='editH2'> Lars Marcoen & Bjorne Baeten & <br /> Jade Corbey | 20.06.2023</h2>
            </div>
          </Link>
        </section>

        <section className='insitus__section' id="post-human">
          <Link to="/post-human">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>InSitu Atelier:</h1>
              <h1 className='editH1'>Post Human</h1>
              <h2 className='editH2'> Lars Marcoen | 29.05.2023</h2>
            </div>
          </Link>
        </section>

        <section className='insitus__section' id="transition-spaces">
          <Link to="/two-towers">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Project:</h1>
              <h1 className='editH1'>Two Towers - LLOSS</h1>
              <h2 className='editH2'>23-24.06.2023</h2>
            </div>
          </Link>
        </section>

        <section className='insitus__section' id="transition-spaces">
          <Link to="/transition-spaces">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Transition spaces</h1>
              <h2 className='editH2'> Lars Marcoen | 14.07.2022</h2>
            </div>
          </Link>
        </section>

        <section className='insitus__section' id="transition-spaces">
          <Link to="/woodblocks">
            <div className='insitus__wrapper'>
              <h1 className='editH1'>Project:</h1>
              <h1 className='editH1'>Woodblocks - Kiosk Radio</h1>
              <h2 className='editH2'>9-10.09.2023</h2>
            </div>
          </Link>
        </section>
      </div>
    </div>
  )
}

export default Insituspage